import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4vgdwvm49: FaireProductEntity = {
  token: "p_v4vgdwvm49",
  type: "product",
  name: "Colombo Water / Milk /Juice Porcelain Bottle w/ Natural Cork",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/6be037e812fd8e830ca755002cdd0b2031c36c0e30ffcb81a13aaee4adfb66a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6a163f83c5a15aa9badde2b8fe478d121d12a9e42291a938968993d8e164cde.jpeg",
    "https://cdn.faire.com/fastly/d9397c62d328177e84709a3769300e386b1865e5db06b48aba0befea9de8cb89.jpeg",
    "https://cdn.faire.com/fastly/6c0b2b960f43e4346da6a9d4dd3756c3274419e2062b167baa0941b273a7f2d3.jpeg",
    "https://cdn.faire.com/fastly/d56270d994e1b1fe766ab082fdb083e1f40977a8029cb5b9c5819a8ae657e4f6.jpeg",
    "https://cdn.faire.com/fastly/0f7bd79694804cb0c63be8bd1f46f6f71d78a8dad4e186a30aa10a80e2b0f535.jpeg",
  ],
  priceDollars: 18.75,
  description:
    'COLOMBO bottle is a versatile table accessory suitable for any occasion and beverage, whether it\'s water, juice, milk, or wine.\n\nEach Colombo bottle has been meticulously hand-crafted from coloured porcelain in rich tones and paired with natural smoked cork.\n\n• Material: porcelain, natural cork\n• Care instructions: Dishwasher safe\n\nAs this piece does not have a handle, please take care when using it for hot liquids.\n\n• Material: Porcelain\n• Size: H 25 x D 9 cm (without the stopper) / H 9.8" x D 3.5" (without stopper)\n• Capacity: 1l / 33.8 fl oz',
  tags: [],
  msrpDollars: 37.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:27.053Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
